import React, { useState } from 'react';
import { useCart } from './CartContext';

function VendorCheckout({ vendorId, onCheckout }) {
  const { cart, updateQuantity, getVendorNote, updateVendorNote, clearVendorCart, removeFromCart } = useCart();

  const vendorNote = getVendorNote(vendorId);
  const [isNoteModalOpen, setIsNoteModalOpen] = useState(false);
  const [tempNote, setTempNote] = useState(vendorNote);

  const vendorCart = cart.filter(item => item.vendorId === vendorId);
  const vendorCartTotal = vendorCart.reduce((sum, item) => sum + (item.totalNumericPrice * item.quantity), 0);
  const mealsInCart = vendorCart.filter(item => item.itemCategory === 'meal');
  const itemsInCart = vendorCart.filter(item => item.itemCategory !== 'meal');

  const handleSaveNote = () => {
    updateVendorNote(vendorId, tempNote);
    setIsNoteModalOpen(false);
  };

  if (vendorCart.length === 0) {
    return null;
  }

  return (
    <div className="vendor-checkout-section">
      <div className="vendor-checkout-header">
        <h2>Your Order</h2>
        <button className="clear-cart-btn" onClick={() => clearVendorCart(vendorId)}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
          <span>Clear Cart</span>
        </button>
      </div>
      <div className="checkout-items">
        {mealsInCart.length > 0 && (
          <div className="checkout-category-group">
            <h3 className="checkout-category-title">Meals</h3>
            {mealsInCart.map((item, idx) => (
              <div key={idx} className="checkout-item">
                <div className="checkout-item-details">
                  <h4>{item.name}</h4>
                  <div className="checkout-item-price">
                    ₦ {(item.totalNumericPrice * item.quantity).toLocaleString()}
                  </div>
                  {item.selectedExtras?.map(ex => <div key={ex.id} className="checkout-item-extra">+ {ex.name}</div>)}
                  {item.selectedSides?.map(side => <div key={side.id} className="checkout-item-extra">+ {side.name}</div>)}
                </div>
                <div className="checkout-item-controls">
                  <div className="checkout-item-quantity-stepper">
                    <button onClick={() => updateQuantity(item.id, item.selectedExtras, item.selectedSides, -1)}>-</button>
                    <span>{item.quantity}</span>
                    <button onClick={() => updateQuantity(item.id, item.selectedExtras, item.selectedSides, 1)}>+</button>
                  </div>
                  <button onClick={() => removeFromCart(item.id, item.selectedExtras, item.selectedSides)} className="checkout-item-remove-btn">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
        {itemsInCart.length > 0 && (
          <div className="checkout-category-group">
            <h3 className="checkout-category-title">Items & Beverages</h3>
            {itemsInCart.map((item, idx) => (
              <div key={idx} className="checkout-item">
                <div className="checkout-item-details">
                  <h4>{item.name}</h4>
                  <div className="checkout-item-price">
                    ₦ {(item.totalNumericPrice * item.quantity).toLocaleString()}
                  </div>
                  {item.selectedExtras?.map(ex => <div key={ex.id} className="checkout-item-extra">+ {ex.name}</div>)}
                  {item.selectedSides?.map(side => <div key={side.id} className="checkout-item-extra">+ {side.name}</div>)}
                </div>
                <div className="checkout-item-controls">
                  <div className="checkout-item-quantity-stepper">
                    <button onClick={() => updateQuantity(item.id, item.selectedExtras, item.selectedSides, -1)}>-</button>
                    <span>{item.quantity}</span>
                    <button onClick={() => updateQuantity(item.id, item.selectedExtras, item.selectedSides, 1)}>+</button>
                  </div>
                  <button onClick={() => removeFromCart(item.id, item.selectedExtras, item.selectedSides)} className="checkout-item-remove-btn">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="vendor-checkout-note-section">
        {vendorNote ? (
          <div className="vendor-note-display-box">
            <div className="vendor-note-text">
              <strong>Note:</strong> {vendorNote}
            </div>
            <button className="edit-note-btn" onClick={() => { setTempNote(vendorNote); setIsNoteModalOpen(true); }}>Edit</button>
          </div>
        ) : (
          <button className="add-note-btn" onClick={() => { setTempNote(vendorNote); setIsNoteModalOpen(true); }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
            <span>Leave a note for the vendor</span>
          </button>
        )}
      </div>
      <div className="checkout-total">
        <h3>Total</h3>
        <h3>₦ {vendorCartTotal.toLocaleString()}</h3>
      </div>
      <button className="vendors-save-btn" style={{ width: '100%', marginTop: '20px' }} onClick={onCheckout}>Go to Checkout</button>

      {isNoteModalOpen && (
        <div className="checkout-modal-overlay" onClick={() => setIsNoteModalOpen(false)}>
          <div className="checkout-modal" onClick={(e) => e.stopPropagation()}>
            <div className="checkout-modal-header">
              <h2>Leave a note for the vendor</h2>
              <button className="checkout-modal-close-btn" onClick={() => setIsNoteModalOpen(false)}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="black" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
              </button>
            </div>
            <div className="checkout-modal-body">
              <textarea
                className="checkout-modal-textarea"
                defaultValue={vendorNote}
                placeholder="Any requests, special vendor instructions etc."
                onChange={(e) => setTempNote(e.target.value)}
              />
            </div>
            <div className="checkout-modal-footer">
              <button className="checkout-modal-btn" onClick={handleSaveNote}>Save Note</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default VendorCheckout;